import { Button, Col, Form, Upload } from 'antd'

import './styles.scss'
import { BiUpload } from 'react-icons/bi'
import { TFieldProps } from '..'

export default function UploadFileFormField({
  fieldInfo,
  subsectionForm = false,
}: TFieldProps) {
  return (
    <Col xl={subsectionForm ? 24 : 8} md={subsectionForm ? 24 : 12} xs={24}>
      <Form.Item
        className={`upload-file-field ${fieldInfo.className ?? ''}`}
        label={fieldInfo.label}
        name={fieldInfo.name}
        required={fieldInfo.required}
        tooltip={fieldInfo.description}
      >
        <Upload listType='text' maxCount={1}>
          <Button className='upload-file-btn' icon={<BiUpload />}>
            Adjuntar archivo
          </Button>
        </Upload>
      </Form.Item>
    </Col>
  )
}
